<template>
  <div>
    <a-card title="修改商品信息" :bordered="false">
      <a-form :form="form" @submit="handleSubmit">
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          label="商品名称"
        >
          <a-input
            v-decorator="[
          'name',
          {rules: [{ required: true, message: '必填项' }],
           initialValue: formData.name,},
           
        ]"
            placeholder="商品名称"
          />

          <a-input
            v-decorator="[
          'id',
          {initialValue: formData.id},
          {rules: [{ required: true, message: '必填项' }]}
        ]"
            placeholder="ID"
            type="hidden"
          />
        </a-form-item>
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          label="商品价格"
        >
          <a-input-number
            :min="0"
            :step="0.01"
            :precision="2"
            v-decorator="[
          'price',
          {initialValue: formData.price,
              rules: []}
        ]"
            placeholder="商品价格"
          />
        </a-form-item>
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          label="带票价格"
        >
          <a-input-number
            :min="0"
            :step="0.01"
            :precision="2"
            v-decorator="[
          'taxPrice',
          {initialValue: formData.taxPrice,
             }
        ]"
            placeholder="带票价格"
          />
        </a-form-item>
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          label="不带票价格"
        >
          <a-input-number
            :min="0"
            :step="0.01"
            :precision="2"
            v-decorator="[
          'taxFreePrice',
           {initialValue: formData.taxFreePrice}
        ]"
            placeholder="不带票价格"
          />
        </a-form-item>
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          label="所属品牌"
        >
          <a-select
            v-decorator="[
          'brandId',
          {initialValue: formData.brandId+'',
              rules: [{ required: true, message: '请选择所属品牌' }]}
        ]"
            placeholder="所属品牌"
          >
            <a-select-option v-for="option in brandList" v-bind:key="option.value">{{ option.text }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          label="商品分类"
        >
          <a-select
            v-decorator="[
          'groupUid',
          {
              initialValue: formData.groupUid,rules: [{ required: true, message: '请选择商品分类' }]}
        ]"
            placeholder="商品分类"
          >
            <a-select-option
              v-for="option in productGroup"
              v-bind:key="option.value"
            >{{ option.text }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          label="商品状态"
        >
          <a-select
            v-decorator="[
          'state',
           {initialValue: formData.state+'',
              rules: [{ required: true, message: '请选择商品状态' }]}
        ]"
            placeholder="商品状态"
          >
            <a-select-option
              v-for="option in productStateList"
              v-bind:key="option.value"
            >{{ option.text }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          label="规格"
        >
          <a-input
            v-decorator="[
          'specification',
          {initialValue: formData.specification,}
        ]"
            placeholder="规格"
          />
        </a-form-item>
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          label="生产厂商"
        >
          <a-select
            v-decorator="[
          'factoryId',
           {initialValue: formData.factoryId,}
        ]"
            placeholder="生产厂商"
          >
            <a-select-option v-for="option in factoryList" v-bind:key="option.id">{{ option.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          label="说明"
        >
          <a-input
            v-decorator="[
          'note',
            {initialValue: formData.note,}
        ]"
            placeholder="说明"
          />
        </a-form-item>

        <a-form-item :label-col="formTailLayout.labelCol" :wrapper-col="formTailLayout.wrapperCol">
          <div>
            <a-button type="primary" html-type="submit">提交</a-button>&nbsp;
            <a-button @click="goBack">取消</a-button>
          </div>
        </a-form-item>
      </a-form>
    </a-card>
  </div>
</template>
<script>
import { Promise } from "q";
const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 8 }
};
const formTailLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 8, offset: 4 }
};
export default {
  name: "productUpdate",
  created() {
    this.$http
      .get("/api/1.0/product/get/" + this.$route.params.id)
      .then(res => {
        this.formData = res.data;
      });
    this.$http.get("api/1.0/brand/list").then(res => {
      this.brandList = res.data;
    });
    this.$http
      .get("/api/1.0/dict/list", { "query-ownGroup-eq": "ProductState" })
      .then(res => {
        this.productStateList = res.data;
      });
    this.$http.get("/api/1.0/productGroup/list").then(res => {
      this.productGroup = res.data;
    });
    this.$http.get("/api/1.0/manufacturer/list").then(res => {
      this.factoryList = res.data;
    });
  },
  mounted() {},
  data() {
    return {
      factoryList: [],
      formData: {},
      productGroup: [],
      brandList: [],
      productStateList: [],
      formItemLayout,
      formTailLayout,
      form: this.$form.createForm(this)
    };
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$http.post("/api/1.0/product/update", values).then(res => {
            this.$http.ajaxResultDue(res, "/product", null);
          });
        }
      });
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
<style scoped>
.ant-input-number {
  width: 100%;
}
</style>

